import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-developer-settings',
    templateUrl: './developer-settings.component.html',
    styleUrls: ['./developer-settings.component.css'],
    standalone: false
})
export class DeveloperSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
